// extracted by mini-css-extract-plugin
module.exports = {"filters":"filtersHoldingRegister_filters__1Kpec","download":"filtersHoldingRegister_download__2OFcY"};